import { createRouter, createWebHistory } from 'vue-router'
import NProgress from '@/utils/progress'

// 静态路由：仅保留流程设计器（iframe 嵌入模式，无登录、无 Layout 外壳）
export const constantRoutes = [
  {
    path: '/',
    name: 'FlowDesigner',
    component: () => import('@/views/flyflow/views/flow/create.vue'),
    meta: { title: '流程设计器' },
  },
  {
    // 通配符兜底：未知路径一律 404
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '404' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  // 设置标题
  to.matched.some((item) => {
    document.title = item.meta.title
  })
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
